import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11.05 12L16 7.05l-1.41-1.41L8.22 12l6.37 6.36L16 16.95 11.05 12z"/>
  </SvgIcon>
);